export default __webpack_public_path__ + "static/media/PUNKS-SHIRT-BACK.308cd7ef.png";